import { Button } from "./button";

export function FormDraftConflict({
	visible,
	onReload,
}: {
	visible: boolean;
	onReload: () => void;
}) {
	if (!visible) return null;
	return (
		<div
			role="alert"
			className="rounded-md border border-amber-500/40 bg-amber-500/10 p-3 text-sm"
		>
			<p>
				This form changed while you were editing. Your edits are preserved.
				Reload the latest values before saving.
			</p>
			<Button
				type="button"
				variant="outline"
				size="sm"
				className="mt-2"
				onClick={onReload}
			>
				Discard edits and reload
			</Button>
		</div>
	);
}
